import React, { useContext } from "react";

import { ThemeContext } from "../../contexts/ThemeContext";

import "./PriceList.css";
import { priceListData } from "../../data/priceList";

function PriceList() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="prices"
      id="price-list"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="prices-body">
        <div className="prices-description">
          <h1 style={{ color: theme.primary }}>Cennik</h1>
        </div>
      </div>
      <div className="prices-body">
        <div className="prices-description">
          <ul>
            {priceListData.prices.map((li, i) => (
              <li key={i}>
                <p style={{ color: theme.tertiary80 }}>{li}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PriceList;
